module.exports = __webpack_public_path__ + "img/Car driver Icon - white.53668356.svg";